module.exports = __webpack_public_path__ + "img/dica3.e99c2c62.jpeg";